import { useRouter } from "next/router";

const useChatRoomId = (): number | undefined => {
  const { query } = useRouter();
  return typeof query.id === "string" ? Number(query.id) : undefined;
};

export default useChatRoomId;
